import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
// Application Layout
// Error catcher
// MUI Style and Icons
import 'typeface-roboto';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import CacheBuster from 'react-cache-buster';
import { CircularProgress } from '@material-ui/core';
import { StylesProvider } from '@mui/styles';
import * as FullStory from '@fullstory/browser';
import ErrorBoundary from './Components/Commons/ErrorBoundary';
import AppLayout from './AppLayout';
import packageInfo from '../package.json';

FullStory.init({ orgId: 'o-1PT2R4-na1', namespace: 'FS' }, ({ sessionUrl }) =>
  console.log(`Started session: ${sessionUrl}`),
);

import './index.css';

Sentry.init({
  dsn: 'https://2e403463c029452d99f202740379ed4b@o832474.ingest.sentry.io/5812785',
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

function App() {
  return (
    <CacheBuster
      currentVersion={packageInfo.version}
      isEnabled={true}
      isVerboseMode={false}
      loadingComponent={<CircularProgress />}
    >
      <StylesProvider injectFirst>
        <ErrorBoundary>
          <CssBaseline />
          <AppLayout />
        </ErrorBoundary>
      </StylesProvider>
    </CacheBuster>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
